export default "__VITE_ASSET__C0eIO6J7__"